import PropTypes from "prop-types";
import { Banner } from "../../molecules/common";
import OptionsInterest from "../../../constant/optionInterest.json";
import { Button, Input, TextArea, Breadcrumbs } from "../../atoms/common";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import SelectBar from "../../atoms/custom/selectBar";
import AOS from 'aos';

const OurWorkPage = (props) => {
  const {dataNews, dataBusiness, dataHeader, sendFeedback} = props;
  const [dataWorkUs, setDataWorkUs] = useState({
    interest_with: '',
    name: '',
    email: '',
    company: '',
    description: '',
  })

  const onSubmit = (e) =>{
    e.preventDefault();
    sendFeedback(dataWorkUs);
  }

  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div>
      <section className="pt-40 desktop:pb-0 pb-12 bg-[#212121] bg-[url('https://images.unsplash.com/photo-1606857521015-7f9fcf423740?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80')] bg-p  desktop:bg-[center_top_5rem] bg-contain bg-no-repeat img-blog overflow-hidden relative">
        <div className="max-w-[1200px] flex mx-auto relative  ">
          <div className="flex flex-col desktop:flex-1 desktop:w-full desktop:items-center px-6 mb-12 w-[52.5%]">
            <div className="text-sm font-bold font1  mb-12 text-[#777]">
              <a className=" " href="/">
                <span className="text-blueLink">Home</span>
              </a>
              <span class="fa mx-2 text-[9px]"></span>
              Our Business
            </div>
            <div className="px-[40px] py-[64px] bg-white desktop:bg-transparent  ">
              <a
                href="single-post.html"
                className=" text-[#212121] inline-block"
              >
                <div className="pre-title-container">
                <div className="relative inline-block mb-4 pr-2 w-full h-5 bg-[#F8F8F8] font1 text-blueLink text-xs font-medium tracking-wider uppercase">
                <div className="relative inline-block mb-4 pl-1 pr-2 bg-[#fff] font1 text-blueLink text-[12px] font-medium tracking-wider uppercase">
                  2847 PROJECTS COMPETED AND COUNTING
                </div>
                </div>
              <div className="pre-title-decoration" />
              </div>
                <h1 className="font2 text-[#333] desktop:text-[#fff] desktop:font-light text-[52px] leading-[1.15] font-semibold mb-2">
                  Case Studies
                </h1>
                <div className="mb-6 text-xl desktop:text-[#fff] font1 desktop:font-light leading-normal">
                  We value our craft, have a deep passion for progression, and exist to solve challenges for brands we believe in
                </div>
              </a>
            </div>
          </div>
          <div className="flex-col flex-auto w-[47.5%] lg-5 px-12 mb-0" />
        </div>
        <div className="gradient-overlay hidden-only-lg" />
      </section>
      <section  className="w-full flex flex-col justify-center bg-white">
        <div className="flex">
        <div className="w-[58%] flex flex-col justify-end pl-20">
            <span className="text-bold text-3xl font-bold text-gray2 font2 py-24 tablet:py-10 tablet:text-xs ">
              We collaborate with ambitious brands and people; we’d love to build something great together.
            </span>
          </div>
          <div className="w-[42%] h-64 tablet:h-36 bg-gray-100"></div>
        </div>

        <div data-aos="fade" className="grid grid-cols-3 tablet:grid-cols-1 gap-4 mx-20 mb-20 tablet:mt-10">
          {dataBusiness?.map((item, index) => (
            <a href="single-post.html" className="max-w-full inline-block">
            <div key={index} className="col-span-1 h-[250px] bg-dark">
              <Banner
                imgUrl={item?.image}
                classes={'bg-no-repeat bg-cover bg-center h-full w-full'}
              >
                <div className="flex items-end w-full h-full text-white">
                  <div className="flex flex-col bg-dark/50 w-full p-2">
                    <span>{item?.title}</span>
                  </div>
                </div>
              </Banner>
            </div>
            </a>
          ))}
        </div>
      </section>
      {/* end */}
      
      <section  className="w-full flex flex-col justify-center bg-white pb-20">
        <div className="flex">
        <div className="w-[30%] h-40 bg-gray-100"></div>
          <div className="w-[70%] flex flex-col justify-end pt-10 pb-5 pl-10">
              <div className="pre-title-container">
                <div className="relative inline-block mb-4 pr-2 w-[70%] h-5 bg-[#F8F8F8] font1 text-blueLink text-xs font-medium tracking-wider uppercase">
                <div className="relative inline-block mb-4 pl-1 pr-2 bg-[#fff] font1 text-blueLink text-[12px] font-medium tracking-wider uppercase">
                  Let's work together
                </div>
                </div>
                <div className="pre-title-decoration" />
              </div>
              <span className="text-bold text-3xl font-medium text-gray2 font2">
              We can help your business grow
              </span>
              <p className="font1 text-gray2 text-xs mt-2">
                Let's have a friendly chat to find out
              </p>
            </div>
          </div>
      </section>
      {/* <section className="w-full flex tablet:flex-col justify-center items-stretch p-10">
        <div className="w-1/2 tablet:w-full p-6 flex items-center">
          <div className="flex flex-col"> 
            <div className="mb-2">
              <span className="text-greenWebsite">OUR FACTS IN NUMBER</span>
            </div>
            <div className="mb-2">
              <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in.</span>
              <Link to={'/'} className="ml-1 text-greenWebsite">
                Read More
              </Link>
            </div>
            <div className="flex flex-wrap">
              <div className="w-1/2 tablet:w-full p-4 flex-col">
                <div className="flex items-end">
                  <span className="text-7xl font-thin">10</span>
                  <span className="text-xl font-thin ml-1">Portfolio Companies</span>
                </div>
                <span className="mt-2 text-base ml-1">
                  We've been operating since 2014
                </span>
              </div>
              <div className="w-1/2 tablet:w-full p-4 flex-col">
                <div className="flex items-end">
                  <span className="text-7xl font-thin">3X</span>
                  <span className="text-xl font-thin ml-1">Value Multiples</span>
                </div>
                <span className="mt-2 text-base ml-1">
                We've helped 990+ clients achieve their goals
                </span>
              </div>
              <div className="w-1/2 tablet:w-full p-4 flex-col">
                <div className="flex items-end">
                  <span className="text-7xl font-thin">6</span>
                  <span className="text-xl font-thin ml-1">Offices</span>
                </div>
                <span className="mt-2 text-base ml-1">
                Our locations are spreaded accross 5 continents
                </span>
              </div>
              <div className="w-1/2 p-4 flex-col">
                <div className="flex items-end">
                  <span className="text-7xl font-thin">20+</span>
                  <span className="text-xl font-thin ml-1">Professionals</span>
                </div>
                <span className="mt-2 text-base ml-1">
                We've awarded as the best business consulting in 2020
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="w-1/2 tablet:w-full p-6">
          <form className="bg-white flex flex-col shadow-md p-6 w-full" onSubmit={onSubmit}>
            <span className="text-4xl font-bold">Work With Us</span>
            <span className="text-md my-2 w-full">We will respond to your email within 24 hours</span>
            <SelectBar
              data={OptionsInterest}
              value={dataWorkUs.interest_with}
              handler={(e) => setDataWorkUs({...dataWorkUs, interest_with: e.target.value})}
              defaultChoose={'Pilih Interest...'}
            />
            <Input
              placeHolder="Name"
              classes={'py-2 w-full bg-white border-b border-gray-500'}
              type="text"
              required
              inputClasses={'border-0 outline-0 focus:outline-none focus:ring-0 w-full placeholder-gray-400'}
              value={dataWorkUs.name}
              handler={(e) => setDataWorkUs({...dataWorkUs, name: e})}
            />
            <Input
              placeHolder="Email"
              classes={'py-2 w-full bg-white border-b border-gray-500'}
              inputClasses={'border-0 outline-0 focus:outline-none focus:ring-0 w-full placeholder-gray-400'}
              value={dataWorkUs.email}
              type="email"
              required
              handler={(e) => setDataWorkUs({...dataWorkUs, email: e})}
            />
            <Input
              placeHolder="Company"
              classes={'py-2 w-full bg-white border-b border-gray-500'}
              inputClasses={'border-0 outline-0 focus:outline-none focus:ring-0 w-full placeholder-gray-400'}
              value={dataWorkUs.company}
              type="text"
              required
              handler={(e) => setDataWorkUs({...dataWorkUs, company: e})}
            />
            <TextArea
              classes={'w-full h-[200px] rounded-m p-1 border-gray-500 border-b'}
              required
              placeHolder={'Project Description'}
              value={dataWorkUs.description}
              handler={(e) => setDataWorkUs({...dataWorkUs, description: e})}
            />
            <Button
              type={'submit'}
              text={'TALK TO OUR TEAM'}
              classes="text-white font-base bg-greenWebsite p-2 rounded-full my-2 w-1/3 tablet:w-1/2"
            />
          </form>
        </div>
      </section> */}
    </div>
  );
};

OurWorkPage.propTypes = {
  linkBanner: PropTypes.string,
};

export default OurWorkPage;


//Copy from connect with us page
// import { Banner } from "../../molecules/common";
// import newsList from "../../../constant/newsLetters.json";
// import moment from "moment";
// import { Button } from "../../atoms/common";
// import { Breadcrumbs } from "../../atoms/common";

// const OurWorkPage = () => {
//   return (
//     <div className="container">
//       <section className="bg-black px-20 py-20">
//           <div className="text-white mt-10">
//             <div className="grid grid-rows-4 z-1">
//               <div className="row-span-1">
//                 <Breadcrumbs/>
//               </div>
//               <div className="row-span-3 w-6/12  px-10 py-10 bg-white text-black text-left">
//                 <p className=".pre-title.is-left-aligned">2847 projects competed and counting</p>
//                 <div class="pre-title-decoration"></div>
//                 <h1>Case Studies</h1>
//                 <p>We value our craft, have a deep passion for progression, and exist to solve challenges for brands we believe in</p>
//               </div>
//             </div>
//           </div>
//       </section>
//       <section className="w-full flex flex-col justify-center bg-white p-10">
//         <span className="text-4xl font-semibold w-2/3">We collaborate with ambitious brands and people; we’d love to build something great together.</span>
//         {/* <div data-aos="fade" className="grid grid-cols-3 gap-4 ">
//           {dataNews?.map((item, index) => (
//             <div key={index} className="first:col-span-2 col-span-1 h-[250px] bg-dark">
//               <Banner
//                 imgUrl={item?.post_image}
//                 classes={'bg-no-repeat bg-cover bg-center h-full w-full'}
//               >
//                 <div className="flex items-end w-full h-full text-white">
//                   <div className="flex flex-col bg-dark/50 w-full p-2">
//                     <span>{item?.post_title}</span>
//                     <p>{converterTagHtml(item?.post_content)}</p>
//                   </div>
//                 </div>
//               </Banner>
//             </div>
//           ))}
//         </div> */}
//       </section>
//     </div>
//   );
// };

// export default OurWorkPage;